module.exports = __webpack_public_path__ + "static/media/indo.0344fe49.svg";